import { memo } from 'react';

import useOneTimeLogout from 'src/hooks/useOneTimeLogout.ts';

const OneTimeLogout = () => {
  useOneTimeLogout();

  return null;
};

export default memo(OneTimeLogout);
